import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import {
  SignalDropdown,
  SignalTextarea,
  SignalTextField,
} from '@vallift/ngl';
import type {
  WorkflowAction,
  WorkflowActionType,
} from '../../utils/workflow-action-catalog';

interface SelectOption<T> {
  label: string;
  value: T;
}

@Component({
  selector: 'app-workflow-action-config-panel',
  standalone: true,
  imports: [SignalTextField, SignalTextarea, SignalDropdown],
  templateUrl: './workflow-action-config-panel.html',
  styleUrl: './workflow-action-config-panel.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowActionConfigPanelComponent {
  readonly action = input.required<WorkflowAction>();
  readonly actionChange = output<WorkflowAction>();
  readonly remove = output<void>();

  readonly methodOptions: SelectOption<string>[] = [
    { label: 'POST', value: 'POST' },
    { label: 'PUT', value: 'PUT' },
    { label: 'PATCH', value: 'PATCH' },
  ];

  readonly draft = signal<Record<string, string>>({});
  private lastActionId: string | null = null;

  constructor() {
    effect(() => {
      const next = this.action();
      if (next.id !== this.lastActionId) {
        this.lastActionId = next.id;
        this.draft.set({ ...next.config });
      }
    });
  }

  isType(type: WorkflowActionType): boolean {
    return this.action().type === type;
  }

  updateConfig(key: string, value: string): void {
    this.draft.update((current) => ({ ...current, [key]: value }));
    this.actionChange.emit({
      ...this.action(),
      config: { ...this.draft() },
    });
  }

  onMethodChange(value: unknown): void {
    if (value !== 'POST' && value !== 'PUT' && value !== 'PATCH') {
      return;
    }
    this.updateConfig('method', value);
  }
}
